import { TableLocale } from 'antd/es/table/interface'
import React, { useMemo } from 'react'

import { TableSkeleton } from '../components/TableSkeleton/TableSkeleton'

/**
 * Returns TableSkeleton in the 'locale' object for the AntD Table while loading.
 * @param loading - Indicates whether the table data are being loaded
 * @param rowsCount - Number of rows to show in the skeleton
 * @param noData - Message to show when there is no data
 * @returns - 'locale' prop object for AntD Table
 */
export function useTableLocale(
  loading: boolean | undefined | null,
  rowsCount?: number,
  noData?: React.ReactNode
): TableLocale {
  return useMemo(
    () => ({
      emptyText: loading ? <TableSkeleton rows={rowsCount} /> : noData,
    }),
    [loading, rowsCount, noData]
  )
}
